import { useMemo } from 'react';
import { haversineDistanceMeters } from '../utils/geo';

interface UseGeofenceInput {
  userLat: number | null;
  userLng: number | null;
  storeLat: number | null;
  storeLng: number | null;
  radiusMeters: number;
}

interface UseGeofenceReturn {
  isInside: boolean | null;
  distanceMeters: number | null;
  formattedDistance: string;
}

export function useGeofence({
  userLat,
  userLng,
  storeLat,
  storeLng,
  radiusMeters,
}: UseGeofenceInput): UseGeofenceReturn {
  return useMemo(() => {
    if (userLat == null || userLng == null || storeLat == null || storeLng == null) {
      return { isInside: null, distanceMeters: null, formattedDistance: '' };
    }

    const dist = Math.round(haversineDistanceMeters(userLat, userLng, storeLat, storeLng));
    const inside = dist <= radiusMeters;

    const formatted =
      dist < 1000 ? `${dist}m` : `${(dist / 1000).toFixed(1)}km`;

    return {
      isInside: inside,
      distanceMeters: dist,
      formattedDistance: formatted,
    };
  }, [userLat, userLng, storeLat, storeLng, radiusMeters]);
}
